import React from "react";
import {
  // BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  useLocation,
  Redirect,
  useRouteMatch,
  useParams,
} from "react-router-dom";
import ProfileEditorDialog from "./User/ProfileEditorDialog";
// import dynamic from 'next/dynamic'
import { inject, observer } from "mobx-react";
import { useEffect } from "react";
// import Dashboard from "./Dashboard/Dashboard";
// import Pack from "./Pack/Pack";
// import Table from "./list/views/table/Table";
import Pack from "./Pack/Pack";
import Dashboard from "./Dashboard/Dashboard";
import { configure } from "mobx";
import ErrorBoundary from "./common/ErrorBoundary";
import { useConfirm } from "material-ui-confirm";
import NotFound from "./common/ErrorMessages";
import OpenAPIDocumentation from "./Header/OpenAPIDocumentation";

import ChatDrawer from "app/Chat/ChatDrawer";

// configure({
// //   enforceActions: "always",
//   computedRequiresReaction: true,
//   reactionRequiresObservable: true,
//   observableRequiresReaction: true,
//   disableErrorBoundaries: true,
// });
// const Table = dynamic(() => import('./list/views/table/Table'), {
//     ssr: false,
//     loading: () => <p>loading...</p>
// })
// const Pack = dynamic(() => import('./Pack/Pack'), {
//     ssr: false,
//     loading: () => <p>loading...</p>
// })
// const cmp = () => <Table />;

// export default Table;
function App({ store }) {
  const history = useHistory();
  const location = useLocation();
  const confirm = useConfirm();
  store.notificationStore.setConfirm(confirm);

  useEffect(() => {
    store.fetchInitialData(history, location);
    changeFavicon();
    // return () => {
    //     // cleanup
    // }
  }, []);

  const changeFavicon = () => {
    var imageName;
    let subdomains = window.location.hostname.split(".");
    if (subdomains.length > 2) imageName = subdomains[subdomains.length - 2];
    var image = new Image();
    image.src = `../../public/images/favicons/${imageName}`;
    if (image.width == 0) imageName = "tigersheet";
    const favicon = document.getElementById("favicon");
    favicon.setAttribute("href", `images/favicons/${imageName}.ico`);
  };

  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <ErrorBoundary>
        <Switch>
          <Route exact path="/">
            <Dashboard />
          </Route>
          <Route exact path="/home">
            <Dashboard />
          </Route>
          <Route path="/packs/index/id/:id">
            <RedirectOldPackUrl />
          </Route>
          <Route path="/pack/:id">
            <Pack />
          </Route>

          <Route exact path="/api/docs">
            <OpenAPIDocumentation />
          </Route>
          <Route exact path="/login1">
            <Login />
          </Route>
          <Route path="" component={NotFound} />
        </Switch>
        <ProfileEditorDialog store={store.userStore} />
        <ChatDrawer />
      </ErrorBoundary>
    </div>
  );
}

function Login() {
  return (
    <form
      method="POST"
      action={process.env.REACT_APP_API_BASE_URL + "/login/validate-login"}
      style={{ padding: 10 }}
    >
      Login
      <input name="email" placeholder="email" />
      <input name="password" type="password" placeholder="password" />
      <button type="submit"> Submit</button>
    </form>
  );
}

function RedirectOldPackUrl(props) {
  const { id } = useParams();
  const listIdHash = window.location.hash.slice(3);
  const listId =
    listIdHash.indexOf("list-tab-") !== -1
      ? listIdHash.slice("list-tab-".length)
      : "";
  let path = `/pack/${id}`;
  if (listId) {
    path += `/list/${listId}`;
  }

  return <Redirect to={path} />;
}

export default inject(({ store }) => ({ store }))(observer(App));
